<template>
  <div>
    <custom-result
      :key="option.flagSelection"
      :is-open="isChangeStatus"
      :has-icon-expand="false"
      :actions="actionsDD"
      :haveCheck="isSubmittedStatus && hasAdvancedFilterPermission"
      :checkVal="options.flagSelection"
      :left-color="getColor(option.statusId)"
      :status-name="option.statusCertificationName | removeParenthesis"
      :cols="3"
      :rows="2"
      custom-board-information-class="col-xs-12 col-sm-6 col-md-6"
      custom-actions-class="col-xs-12 col-sm-3 col-md-3 actions d-flex pr-0 justify-content-end"
      @action="clickDD"
      @chekValue="getValueCheck"
    >
      <template #status_bottom>
        <div class="status_bottom mt-3">
          <div class="first">
            <span class="font-weight-normal">Certificación:</span>
            <p>{{ option.certificationNumber }}</p>
          </div>
        </div>
      </template>

      <template #board_information>
        <div class="col-12 row mx-auto info">
          <div class="col-sm-6 col-md-6 data">
            <span>Escuela:</span>
            <p>{{ option.schoolCdName }}</p>
          </div>
          <div class="col-sm-6 col-md-3 data">
            <span>Región:</span>
            <p>{{ option.regionName }}</p>
          </div>
          <div class="col-sm-6 col-md-3 data">
            <span>Municipio:</span>
            <p>{{ option.municipalityName }}</p>
          </div>
          <div class="col-sm-6 col-md-6 data">
            <span>Total de incidencias disciplinarias reportadas:</span>
            <p>{{ option.totalIncidents }}</p>
          </div>
          <div class="col-sm-6 col-md-6 data">
            <span>Cantidad estudiantes con incidencias disciplinarias:</span>
            <p>{{ option.studentsWithIncidents }}</p>
          </div>
        </div>
      </template>

      <template v-if="isChangeStatus" #board_details>
        <div class="w-100 p-3">
          <div class="w-100">
            <em class="fas text-orange" :class="changePropsStatus.icon" />
            <span class="ml-2">{{ changePropsStatus.actionStatusName }}</span>
          </div>
          <validation-observer ref="validator">
            <div class="d-flex flex-direction mt-3 w-100">
              <validation-provider
                v-slot="{ errors }"
                class="flex-grow-2"
                rules="required"
              >
                <div>
                  <label class="input-label">Comentario:</label>
                  <CustomTextArea
                    v-model="changePropsStatus.comment"
                    :show-char-count="true"
                    :error="errors[0]"
                    :custom-error-msg="messages['0675']"
                    :maxlength="maxchars"
                    type="text"
                  />
                </div>
              </validation-provider>
            </div>
          </validation-observer>
          <div class="d-flex justify-content-end mt-4">
            <action-button
              variant="danger mr-2"
              i="fas fa-times-circle"
              text="Cancelar"
              @click="dispose"
            />
            <action-button
              variant="success"
              text="Guardar"
              @click="changePropsStatus.save"
            />
          </div>
        </div>
      </template>
    </custom-result>

    <StatusTimeLine
      v-if="showHistory"
      :history="historyList"
      @hide="showHistory = false"
    />
  </div>
</template>

<script>
import { CustomResult } from '@/components/common/FilterCustomManager';
import { Colors } from '../../common';
import alert from '@/mixin/alert.mixin';
import statusEnum from '@/utils/constants/student/childCountStatusEnum';
import { ActionButton } from '@/components/common';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomTextArea from '@/components/common/CustomTextArea';
import StatusTimeLine from './StatusTimeLine';
import services from '@/services/api/disciplineCertification.api';
export default {
  name: 'RowChildCount',
  mixins: [alert],
  components: {
    CustomResult,
    CustomTextArea,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    StatusTimeLine,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    messages: {
      type: Object,
      default: () => [],
    },
    onActionCompleted: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      option: this.options,
      isChangeStatus: false,
      showHistory: false,
      historyList: [],
      changePropsStatus: {
        actionStatusName: '',
        icon: '',
        reasons: [],
        reason: null,
        comment: null,
        save: () => {},
      },
      statusTo: null,
      maxchars: 3000,
    };
  },
  computed: {
    actionsDD() {
      return [
        {
          Title: 'Entrar',
          Icon: 'fas fa-arrow-alt-from-left',
          IconColor: 'text-green',
          Type: 'Menu',
          Item: 1,
          Visible: true,
          EmitGo: 'option',
          Children: [],
        },
        {
          Title: 'Aprobar',
          Icon: 'fas fa-calendar-check',
          IconColor: 'text-green',
          Type: 'Menu',
          Item: 2,
          Visible: this.isApproveActionVisible(this.option.statusId),
          EmitGo: 'option',
          Children: [],
        },
        {
          Title: 'Denegar',
          Icon: 'fas fa-times-square',
          IconColor: 'text-red',
          Type: 'Menu',
          Item: 3,
          EmitGo: 'option',
          Visible: this.isDenyActionVisible(this.option.statusId),
          Children: [],
        },
        {
          Title: 'Historial',
          Icon: 'fas fa-clock',
          IconColor: 'text-red',
          Type: 'Menu',
          Item: 4,
          EmitGo: 'option',
          Children: [],
        },
        {
          Title: 'Regresar Estatus',
          Icon: 'fas fa-reply-all',
          IconColor: 'text-green',
          Type: 'Menu',
          Item: 5,
          Visible:
            this.option.statusId != statusEnum.new &&
            this.canreturnPreviousStatus,
          EmitGo: 'option',
          Children: [],
        },
      ];
    },
    params() {
      return {
        certificationId: this.option.certificationId,
      };
    },
    isSubmittedStatus() {
      return this.options.statusId === statusEnum.submited;
    },
    canreturnPreviousStatus() {
      return this.$store.getters.HasPermission(
        'academic.student.disciplinecertification.schoollevel.reverse'
      );
    },
    hasAdvancedFilterPermission() {
      return this.$store.getters.HasPermission(
        'academic.student.disciplinecertification.showadvance'
      );
    },
  },
  methods: {
    getColor: (status) => {
      let color = '';
      switch (status) {
        case statusEnum.new:
          color = Colors.GRAY;
          break;
        case statusEnum.approved:
          color = Colors.GREEN;
          break;
        case statusEnum.submited:
          color = Colors.YELLOW;
          break;
        case statusEnum.denied:
          color = Colors.BROWN;
          break;
      }
      return color;
    },

    async enterAction() {
      await this.$ApiGet('/api/childcount/enter').then(async (res) => {
        if (res && res.data) {
          //
          this.dispose();
        }
      });
    },
    isApproveActionVisible(status) {
      return (
        status == statusEnum.submited &&
        this.$store.getters.HasPermission(
          'academic.student.disciplinecertification.schoollevel.approve'
        )
      );
    },
    isDenyActionVisible(status) {
      return (
        status == statusEnum.submited &&
        this.$store.getters.HasPermission(
          'academic.student.disciplinecertification.schoollevel.deny'
        )
      );
    },
    async approveAction(args = {}) {
      const response = await this.ShowCancelModal(
        this.messages['R90020'] || 'Aviso',
        (this.message =
          this.messages['R150005']
            .replace('{0}', this.option.certificationNumber)
            .replace('{1}', this.option.schoolCdName) ||
          '¿Está seguro que desea aprobar la certificación ' +
            this.option.certificationNumber +
            ' correspondiente a la escuela ' +
            this.option.schoolCdName +
            '?')
      );

      if (response) {
        this.statusTo = statusEnum.approved;
        await this.$ApiPost('/api/discipline/approve', {
          ...this.params,
          ...args,
        })
          .then(async () => {
            this.ShowToast(
              'Completado',
              'Las certificaciones han sido aprobadas exitosamente.',
              this.toastType.Success
            );
            this.option = {
              ...this.option,
              statusId: statusEnum.approved,
              statusCertificationName: 'Aprobado',
            };

            if (this.onActionCompleted != null) this.onActionCompleted();

            this.dispose();
          })
          .catch((err) => {
            this.ShowToast(err.response.data.message, '', 'error');
          });
      }
    },

    async deniedAction() {
      this.isChangeStatus = true;

      this.changePropsStatus = {
        ...this.changePropsStatus,
        actionStatusName: 'Denegar',
        icon: 'fa-times-square',
        save: this.doDeniedRequest,
      };
    },

    async doDeniedRequest() {
      if (this.changePropsStatus.comment) {
        const response = await this.ShowCancelModal(
          this.messages['R90020'].replace(
            '{0}',
            this.option.certificationNumber
          ) || 'Aviso',
          (this.message =
            this.messages['R150006']
              .replace('{0}', this.option.certificationNumber)
              .replace('{1}', this.option.schoolCdName) ||
            '¿Está seguro que desea denegar la certificación ' +
              this.option.certificationNumber +
              ' correspondiente a la escuela ' +
              this.option.schoolCdName +
              '?')
        );

        if (response) {
          this.statusTo = statusEnum.denied;
          await this.$ApiPost('/api/discipline/deny', {
            ...this.params,
            comment: this.changePropsStatus.comment,
          })
            .then(async () => {
              this.ShowToast(
                'Completado',
                'Su información ha sido completada exitosamente.',
                this.toastType.Success
              );
              this.option = {
                ...this.option,
                statusId: statusEnum.denied,
                statusCertificationName: 'Denegado',
              };

              if (this.onActionCompleted != null) this.onActionCompleted();

              this.dispose();
            })
            .catch((err) => {
              this.ShowToast(err.response.data.message, '', 'error');
            });
        }
      } else {
        await this.$refs.validator.validate();
        this.ShowToast('Alerta', this.messages['R150007'], 'error');
      }
    },

    async clickDD(item) {
      await this.$store.commit(
        'setShowEditionCallaout',
        !this.$store.state.showEditionCallaout
      );
      switch (item) {
        case 1:
          this.$router.push({
            name: 'DisciplineInformation',
            params: {
              certificationId: this.params.certificationId,
            },
          });
          break;
        case 2:
          this.approveAction();
          break;
        case 3:
          this.showHistory = false;
          this.deniedAction();
          break;
        case 4:
          this.showHistory = !this.showHistory;
          break;
        case 5:
          this.changePreviousStatus();
          break;
      }
    },
    async getValueCheck(val) {
      try {
        await services.markIndividualToChangeStatus(
          this.option.certificationId,
          val
        );
        this.$emit('individualCheckValue', val);
      } catch (err) {
        this.ShowToast(
          '',
          err?.response?.data?.message || err?.message || 'Error',
          this.toastType.Error
        );
      }
    },
    async changePreviousStatus(val) {
      const response = await this.ShowCancelModal(
        this.messages['R90020'] || 'Aviso',
        '¿Está seguro que desea revertir la certificación ' +
          this.option.certificationNumber +
          ' correspondiente a la escuela ' +
          this.option.schoolCdName +
          '?'
      );
      if (response) {
        try {
          await services.changePreviousStatus(this.option.certificationId, val);
          this.ShowToast(
            'Completado',
            'Se revertió estatus de certificación exitosamente.',
            this.toastType.Success
          );
          this.$emit('returnStatus', val);
        } catch (err) {
          this.ShowToast(
            '',
            err?.response?.data?.message || err?.message || 'Error',
            this.toastType.Error
          );
        }
      }
    },
    dispose() {
      this.isChangeStatus = false;
      this.changePropsStatus = {
        actionStatusName: '',
        icon: '',
        reasons: [],
        reason: null,
        comment: null,
        save: () => {},
      };
    },
  },
  filters: {
    removeParenthesis(status) {
      if (status.includes('(') && status.includes(')')) {
        let idxOpend = status.indexOf('(');
        let idxClosed = status.indexOf(')');
        let nwStatus = `${status.substr(0, idxOpend)} - ${status.substring(
          idxOpend + 1,
          idxClosed
        )}`;
        return nwStatus;
      }
      return status;
    },
  },
  watch: {
    options(nw) {
      this.option = nw;
      this.showHistory = false;
    },
    '$store.state.showEditionCallaout': function() {
      this.isChangeStatus = false;
    },
    showHistory: {
      async handler(val) {
        if (val === true) {
          const { data } = await services.getHistory(
            this.option.certificationId
          );
          this.historyList = data;
        }
      },
    },
  },
};
</script>

<style scoped>
.fsi {
  font-size: 26px;
  color: #3f5b60;
  cursor: pointer;
}
.icon-green {
  color: #2db782;
}
.with-border {
  border-right: 1px solid #727272;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: #b7c7bf;
}
.dropdown-item .cursor-pointer {
  border-bottom: 1px solid #e2e2e2;
}
.edition-title {
  color: #3f5b60;
}

.gap {
  margin-right: 3%;
}

.info .data > div {
  float: left;
  width: 33%;
}

.info .data span {
  font-size: 14px;
  font-weight: 400;
}

.info .data p {
  font-size: 16px;
  color: black;
  font-weight: 500;
  margin-top: 0.5rem;
}

.details .data {
  padding-left: 2.5rem !important;
}

.details .data span {
  font-size: 14px;
}

.details .data p {
  margin-top: 5px;
}

.status_bottom > div {
  padding-bottom: 5px;
  padding-left: 0;
  padding-right: 0;
}

.status_bottom span,
.status_bottom p {
  color: black;
}

.status_bottom p {
  margin-top: 0.5rem;
}

@media screen and (max-width: 1237px) {
  .info .data {
    margin-left: 0rem;
    padding-left: 0rem;
  }
}

@media screen and (max-width: 1078px) {
  .status_bottom .first {
    width: 100% !important;
    max-width: 100% !important;
    text-align: left;
  }

  .status_bottom .last {
    clear: both;
    width: 100% !important;
    max-width: 100% !important;
    text-align: left;
  }

  .info .data > div {
    width: 50%;
  }
}

@media screen and (max-width: 1050px) {
  .status_bottom {
    margin-top: 5%;
    margin-left: 0.5rem !important;
  }
}

@media screen and (max-width: 850px) {
  .status_bottom {
    flex-direction: column;
  }

  .status_bottom div {
    padding-left: 0;
    margin-right: 0;
  }
}

@media screen and (max-width: 600px) {
  .flex-direction {
    flex-direction: column;
  }

  .gap {
    margin-right: 0;
  }
}

@media screen and (max-width: 576px) {
  .info .data {
    margin-left: 0rem;
    padding-left: 0rem;
  }

  .status_bottom .last {
    clear: both;
    width: 100% !important;
    max-width: 100% !important;
  }

  .info .data > div {
    width: 100%;
  }
}

@media screen and (min-width: 577px) {
  .status_bottom div {
    text-align: center;
  }
}
</style>
